/**
 * Multihub Logo (monochrome black)
 *
 * Full wordmark for light backgrounds.
 */

import type { ImageLogoProps } from '../types';

import multihubLogoMonoBlackUrl from './multihub-logo-mono-black.svg';

const ASPECT_RATIO = 1473.49 / 217.42;

export function MultihubLogoMonoBlack({
  height = 32,
  width,
  alt = 'Multihub',
  ...props
}: ImageLogoProps) {
  const computedWidth =
    width ?? (typeof height === 'number' ? height * ASPECT_RATIO : undefined);

  return (
    <img
      src={multihubLogoMonoBlackUrl}
      alt={alt}
      height={height}
      width={computedWidth}
      {...props}
    />
  );
}
